'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _themes = require('@marmalade/themes');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _lib = require('@marmalade/format/lib/');
var _lib2 = _interopRequireDefault(_lib);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var levelStyles = function levelStyles(_ref) {
  var noMargin = _ref.noMargin,
    theme = _ref.theme,
    _ref$breakpoint = _ref.breakpoint,
    breakpoint = _ref$breakpoint === undefined ? 'sm' : _ref$breakpoint,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, ['noMargin', 'theme', 'breakpoint', 'children']);
  return Object.assign(_defineProperty({
    display: 'flex',
    marginTop: theme.space_md,
    marginBottom: theme.space_md,
    flexWrap: 'wrap',
    justifyContent: 'space-around'
  }, (0, _themes.between)(0, theme['breakpoint_' + breakpoint]), {
    flexDirection: 'column',
    alignItems: 'center'
  }), rest);
};
exports.default = _glamorous2.default.div(levelStyles);